import { vm } from "@/main.js";

const downloadFile = (text, nameFile) => {
  const url = "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(text, null, 4));
  var link = document.createElement("a");
  link.setAttribute("download", nameFile + ".json");
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const notify = (title, text, color = "success", position = "top-right") => {
  vm.$vs.notify({ title, text, color, position });
};

const confirm = ({
  title,
  text,
  accept,
  cancel = null,
  color = "danger",
  type = "confirm",
  acceptText = "Aceptar",
  cancelText = "Cancelar",
  templete = false
} = {}) => {
  vm.$vs.dialog({
    type: type,
    color: color,
    title: title,
    text: templete ? "" : text,
    accept: accept,
    cancel: cancel,
    acceptText,
    cancelText
  });
  if (templete) {
    setTimeout(() => {
      const element = document.querySelector("body div.vs-dialog-text");
      element.innerHTML = text;
    }, 90);
  }
};

const generateRandomKey = () => {
  return Math.random().toString(36).substring(2, 34) + Math.random().toString(36).substring(2, 34);
};

export { notify, downloadFile, confirm, generateRandomKey };
